import { FormControl } from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { sortBySortOrder } from '@/utils/sort';
import type { SurveyQuestionDetail } from '../../types/survey.types';
import { AnswerOptionRow } from './AnswerOptionRow';

interface McqAnswerInputProps {
  name: string;
  options: SurveyQuestionDetail['options'];
  value: string;
  onChange: (value: string) => void;
  invalid: boolean;
}

export function McqAnswerInput({ name, options, value, onChange, invalid }: McqAnswerInputProps) {
  const sortedOptions = sortBySortOrder(options);

  return (
    <FormControl>
      <RadioGroup
        value={value}
        onValueChange={onChange}
        className="space-y-2"
        aria-invalid={invalid || undefined}
      >
        {sortedOptions.map((option) => {
          const optionId = `${name}-option-${option.id}`;
          return (
            <AnswerOptionRow key={option.id} optionId={optionId} label={option.text}>
              <RadioGroupItem value={String(option.id)} id={optionId} />
            </AnswerOptionRow>
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}
